module.exports = __webpack_public_path__ + "img/普陀女.ddab0e67.png";